/**
 * Create CSS rule for a font-feature-settings
 * 
 * @see: https://developer.mozilla.org/en-US/docs/Web/CSS/font-feature-settings
 * @param feature Either a complete and correct font-feature-settings feature-tag-value or a comma separated list of Binary features to turn on.
 * @returns 
 */
export function opentypeFeatureCSS(feature: string): string {
    let rule;

    // null or empty string input means empty output
    if (!feature) {
        return '';
    }

    // test a valid feature-tag-value as per https://developer.mozilla.org/en-US/docs/Web/CSS/font-feature-settings#values
    const featureTagValueValidator =  /^\s*['"]....['"]\s+\d+(\s*,\s*['"]....['"]\s+\d+)*\s*$/;

    // If it's valid just let it pass through.
    if (featureTagValueValidator.test(feature)) {
        rule = feature;
    } else {
        // strip quotes out if they already exist to make parsing easier, we'll add them back later.
        feature = feature.replace(/["']/g, '').trim();

        // early out if someone just passed us qoutes, we should probably prevent this as a possible input. 
        // early out for "normal"
        if (!feature || feature.toLowerCase() === 'normal') {
            return '';
        }

        // we expect a comma separated list of features, and we will be turning them all all. 
        rule = feature.split(',')
            // we're going to turn them all to on explicitly. 
            // we are assuming we're only setting binary values. this is a naieve approach
            .map((feat) => `"${feat.trim()}" 1`)
            // rejoin them on commas
            .join(', ');
    }

    // okay otherwise build the font-feature-settings chain
    return [
        `-moz-font-feature-settings:${rule}`,
        `-ms-font-feature-settings:${rule}`,
        `-webkit-font-feature-settings:${rule}`,
        `font-feature-settings:${rule}`,
    ].join('; ');
}